module.exports = __webpack_public_path__ + "img/graph_2.b9627509.svg";